import axios from 'axios';

export const getKeypairs = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/os-keypairs`, settings);
}

export const createKeyPair = async (apiUrl, region, data) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.post(`${apiUrl}/os-keypairs`, data, settings);
}

export const deleteKeyPair = async (apiUrl, keyPairId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  console.log('regionTokenData' , region )
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/os-keypairs/${keyPairId}`, settings);
}
